module.exports = __webpack_public_path__ + "static/media/goback.4e211f22.svg";